import { isEmpty, isEqual, uniq } from 'lodash';

function isStringValid(s) {
  const isString = typeof s === 'string' || s instanceof String;
  const isNameEmpty = isString ? isEmpty(s.trim()) : true;

  return !(!isString || isNameEmpty);
}

function isNameValid(name) {
  return isStringValid(name);
}

function isEquationValid(equation) {
  return isStringValid(equation);
}

function areAllParametersPicked(parameters, assignmentParameters) {
  return parameters.every((parameter) =>
    assignmentParameters.includes(parameter)
  );
}

function areDuplicatedValuesInArray(array) {
  return isEqual(uniq(array).sort(), array.sort());
}

export default {
  isNameValid,
  isEquationValid,
  areAllParametersPicked,
  areDuplicatedValuesInArray,
};
